export function buildInitialStateData(mappingCharts) {
  const initialValue = {};
  return Object.keys(mappingCharts).reduce((obj, idChart) => {
    return {
      ...obj,
      [idChart]: []
    };
  }, initialValue);
}
